import { useEffect, useState } from 'react';
import { fetchHasPremium, PremiumCourseName } from 'shared/api/fetchPremiumData';
import { fetchPriceData, Price } from 'shared/api/fetchPriceData';
import { fetchProfileData, isAuthorizedProfile } from 'shared/api/fetchProfileData';
import { PAYMENT_LINK } from 'shared/constants';

const INITIAL_PRICE_DATA = { price: null, paymentPath: null };

export const usePriceData = (productName: PremiumCourseName, testPrice?: number) => {
  const [priceData, setPriceData] = useState<Price>(INITIAL_PRICE_DATA);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const profileData = await fetchProfileData();

        const isAuthorized = isAuthorizedProfile(profileData);

        if (isAuthorized) {
          await setAuthorizedPriceData(productName, testPrice);
        } else {
          setUnauthorizedPriceData(productName);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    fetchData();
  }, [testPrice, productName]);

  const setUnauthorizedPriceData = (name: PremiumCourseName) => {
    const defaultPaymentPath = `${PAYMENT_LINK}?from=${name}`;

    setPriceData({ price: null, paymentPath: defaultPaymentPath });
  };

  const setAuthorizedPriceData = async (name: PremiumCourseName, price?: number) => {
    const hasPremium = await fetchHasPremium(name);

    if (hasPremium) {
      setPriceData(INITIAL_PRICE_DATA);
    } else {
      const response = await fetchPriceData(name, price);
      setPriceData(response);
    }
  };

  return priceData;
};
